import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Search, Send, TrendingUp } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    icon: <Search className="w-8 h-8 text-brand-cyan" data-id="element-92" />,
    title: 'Auditoría',
    desc: 'Sigues la guía para encontrar los errores que la IA del banco usa para rechazarte.'
  }, {
    num: '02',
    icon: <Send className="w-8 h-8 text-brand-cyan" data-id="element-93" />,
    title: 'Ataque',
    desc: 'Envías las Cartas de Oro usando nuestro formato humano que burla los filtros automáticos.'
  }, {
    num: '03',
    icon: <TrendingUp className="w-8 h-8 text-brand-cyan" data-id="element-94" />,
    title: 'Escalada',
    desc: 'Aplicas el blindaje de puntaje para subir tus puntos y mantenerlos ahí para siempre.'
  }];
  return <SectionWrapper className="bg-brand-darker" data-id="element-95">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <h2 className="text-4xl md:text-5xl font-display uppercase mb-4" data-id="element-98">
            Cómo funciona el sistema
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-99">
            Tres pasos simples. Cero abogados.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-100">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gray-800 z-0" data-id="element-101"></div>

          {steps.map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-102">
              <div className="w-24 h-24 bg-brand-card border-2 border-brand-cyan rounded-full flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(0,229,255,0.15)]" data-id="element-103">
                {step.icon}
              </div>
              <div className="text-brand-cyan font-display text-xl mb-2" data-id="element-104">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-105">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-106">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}